import { render, staticRenderFns } from "./WidgetView.vue?vue&type=template&id=63cb79a0&scoped=true&lang=pug&"
import script from "./WidgetView.vue?vue&type=script&lang=ts&"
export * from "./WidgetView.vue?vue&type=script&lang=ts&"
import style0 from "./WidgetView.vue?vue&type=style&index=0&id=63cb79a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cb79a0",
  null
  
)

export default component.exports